import { render, staticRenderFns } from "./optionItems.vue?vue&type=template&id=a0ac4e2a"
import script from "./optionItems.vue?vue&type=script&lang=js"
export * from "./optionItems.vue?vue&type=script&lang=js"
import style0 from "./optionItems.vue?vue&type=style&index=0&id=a0ac4e2a&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0ac4e2a')) {
      api.createRecord('a0ac4e2a', component.options)
    } else {
      api.reload('a0ac4e2a', component.options)
    }
    module.hot.accept("./optionItems.vue?vue&type=template&id=a0ac4e2a", function () {
      api.rerender('a0ac4e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/optionItems.vue"
export default component.exports